import script from "./MDTextInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MDTextInput.vue?vue&type=script&setup=true&lang=js"

import "./MDTextInput.vue?vue&type=style&index=0&id=1c4bfaf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4bfaf1"]])

export default __exports__